var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('portal-sysbar'),_c('div',{staticClass:"main-content"},[_c('portal-aside'),_c('portal-title',{attrs:{"title":_vm.$t('message.aside.infoloc', { value: 'default' })}}),_c('portal-breadcumb'),_c('div',{staticClass:"content"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }